module.exports = __webpack_public_path__ + "img/mid.9b6ea54b.svg";